<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path stroke="#000" stroke-linecap="round" stroke-width="2" d="M2 12v7M10 1v18M18 5v14"/></svg>
</template>

<script>
export default {
  name: "CompareIcon"
}
</script>
